import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.m.css";
import { VikatanCollectionResponsive } from "../../rows/ad-free";
import { get } from "lodash";

const AdUnit = props => {
  const index = get(props, ["index"], 0);
  let DesktopunitName =
    index === 4
      ? "Vikatan_Desktop_HP_MID_728x90"
      : index === 6
        ? "Vikatan_Desktop_HP_MID2_728x90"
        : index === 8
          ? "Vikatan_Desktop_HP_MID3_728x90"
          : index === 10
            ? "Vikatan_Desktop_HP_MID4_728x90"
            : index === 12
              ? ""
              : index === 14
                ? "Vikatan_Desktop_HP_MID6_728x90"
                : index === 16
                  ? "Vikatan_Desktop_HP_BTF_728x90"
                  : index === 18
                    ? "Vikatan_Desktop_HP_BTF2_728x90"
                    : index === 20
                      ? "Vikatan_Desktop_HP_BTF3_728x90"
                      : "Vikatan_Desktop_HP_MID_728x90";

  let MobileunitName =
    index === 4
      ? "Vikatan_Mobile_HP_MID_320x100"
      : index === 6
        ? "Vikatan_Mobile_HP_MID2_320x100"
        : index === 8
          ? "Vikatan_Mobile_HP_MID3_320x100"
          : index === 10
            ? "Vikatan_Mobile_HP_MID4_320x100"
            : index === 12
              ? ""
              : index === 14
                ? "Vikatan_Mobile_HP_BTF_320x100"
                : index === 16
                  ? "Vikatan_Mobile_HP_BTF2_320x100"
                  : index === 18
                    ? "Vikatan_Mobile_HP_BTF3_320x100"
                    : index === 20
                      ? "Vikatan_Mobile_HP_BTF4_320x100"
                      : "Vikatan_Mobile_HP_MID_320x100";
  return (
    <div className={styles["header-ad-unit"]}>
      <VikatanCollectionResponsive
        DesktopAdtype={DesktopunitName}
        MobileAdtype={MobileunitName}
        placement={props.placement}
      />
    </div>
  );
};

AdUnit.propTypes = {
  placement: PropTypes.string,
  index: PropTypes.number
};

export default AdUnit;
